import when from 'ramda/src/when'

const setMetaKeyDownTo = function(b) {
  window.metaKeyDown = b
}

const completeHandler = e => {
  setMetaKeyDownTo(false)
  document.removeEventListener('keyup', completeHandler)
  document.removeEventListener('keydown', completeHandler)
}

const fn = _ => {
  setMetaKeyDownTo(true)
  document.addEventListener('keyup', completeHandler, false)
  document.addEventListener('keydown', completeHandler, false)
}

export default _ => {
  setMetaKeyDownTo(false)
  document.addEventListener('keydown', when(e => e.metaKey || !window.metaKeyDown, fn), false)
}



// WEBPACK FOOTER //
// ./src/helpers/handleMetaKeyInput.js